import React, {Component} from 'react';
import PropTypes from 'prop-types';
import css from './groupsList.scss';
import Popup from '../popup/popup';
import DeleteGroup from './deleteGroup';
import {Mutation} from 'react-apollo';
import {UPDATE_GROUP} from './queries';

class UpdateGroup extends Component {
	state = this.props;
	static propTypes = {
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	};
	isModified = _ => {
		for (let key in this.state) {
			if (this.props[key] !== this.state[key]) {
				return true;
			}
		}
		return false;
	};
	updateState = (e, callback) => {
		let state = {};
		state[e.target.name] = e.target.value;
		if (e.target.type === 'checkbox') {
			state[e.target.name] = e.target.checked;
		}
		this.setState(_ => state, callback);
	};
	render() {
		const itemClass = [css.item, this.isModified() ? 'modified' : ''];
		return (
			<Mutation mutation={UPDATE_GROUP} variables={this.state}>
				{(updateGroup, {loading, error}) => (
					<li
						className={itemClass
							.concat(loading ? 'loading' : '')
							.join(' ')}
						title={this.state.name}
					>
						<DeleteGroup groupId={this.props.id} />
						<form
							onSubmit={e => {
								e.preventDefault();
								updateGroup();
							}}
						>
							<input
								type="text"
								value={this.state.name}
								name="name"
								placeholder="Nom"
								onChange={this.updateState}
							/>
							<input type="submit" hidden />
							{error && (
								<Popup opened>
									{error.graphQLErrors[0]}
								</Popup>
							)}
						</form>
					</li>
				)}
			</Mutation>
		);
	}
}

export default UpdateGroup;



// WEBPACK FOOTER //
// ./src/groupsList/updateGroup.js